import dayjs from "dayjs";

export const createEmptyEntry = () => ({
  wh_type: "",
  wh_position: "",
  wh_comm_vehicle: "",
  wh_comm_vehicle_types: [],
  wh_name: "",
  wh_address1: "",
  wh_address2: "",
  wh_city: "",
  wh_province: "",
  wh_country: "",
  wh_postcode: "",
  wh_confname: "",
  wh_conlname: "",
  wh_contact_position: "",
  wh_phone: "",
  wh_email: "",
  wh_datefrom: "",
  wh_dateto: "",
  wh_status: "No",
  wh_terminated: "",
  wh_reason: "",
  wh_graduated: "",
  wh_gpa: "",
  wh_hours_of_instruction: "",
  wh_branch_service: "",
  wh_military_rank: "",
  wh_dot_safety_sensitive: "",
  wh_fmcsa: "",
  wh_skills_border: false,
  wh_skills_logbooks: false,
  wh_skills_fmcr: false,
  wh_skills_hazmat: false,
});

const trimValue = (value) => typeof value === "string" ? value.trim() : value;

export const validateWorkHistoryEntry = (entry, options = {}) => {
    const stillWorking = entry.wh_status === "Yes";
    const nextErrors = {};

    if (!trimValue(entry.wh_datefrom)) {
      nextErrors.wh_datefrom = "From date is required.";
    }

    if (!stillWorking && !trimValue(entry.wh_dateto)) {
      nextErrors.wh_dateto = "To date is required.";
    }

    if (
      entry.wh_datefrom &&
      entry.wh_dateto &&
      !stillWorking &&
      dayjs(entry.wh_dateto).isBefore(dayjs(entry.wh_datefrom), "day")
    ) {
      nextErrors.wh_dateto = "To date must be on or after From date.";
    }

    if (
      entry.wh_type === "Working" ||
      entry.wh_type === "Driving School" ||
      entry.wh_type === "School"
    ) {
      if (!trimValue(entry.wh_name)) {
        nextErrors.wh_name = "Company / School name is required.";
      }
      if (!trimValue(entry.wh_country)) {
        nextErrors.wh_country = "Country is required.";
      }
    }

    if (entry.wh_type === "Working") {
      if (!trimValue(entry.wh_position)) {
        nextErrors.wh_position = "Position is required.";
      }
      if (!trimValue(entry.wh_comm_vehicle)) {
        nextErrors.wh_comm_vehicle =
          "Commercial vehicle selection is required.";
      }
      if (
        entry.wh_comm_vehicle === "Yes" &&
        (entry.wh_comm_vehicle_types || []).length === 0
      ) {
        nextErrors.wh_comm_vehicle_types =
          "Select at least one commercial vehicle type.";
      }
      if (!trimValue(entry.wh_confname)) {
        nextErrors.wh_confname = "Contact first name is required.";
      }
      if (!trimValue(entry.wh_contact_position)) {
        nextErrors.wh_contact_position = "Contact position is required.";
      }
      if (!trimValue(entry.wh_phone)) {
        nextErrors.wh_phone = "Phone is required.";
      }
      if (!trimValue(entry.wh_email)) {
        nextErrors.wh_email = "Email is required.";
      }
      if (!trimValue(entry.wh_terminated)) {
        nextErrors.wh_terminated = "Terminated selection is required.";
      }
      if (options.requireWorkReason !== false && !trimValue(entry.wh_reason)) {
        nextErrors.wh_reason = "Reason for leaving is required.";
      }
    }

    if (entry.wh_type === "School" && !trimValue(entry.wh_position)) {
      nextErrors.wh_position = "Level of education is required.";
    }
    if ((entry.wh_type === "Driving School" || (entry.wh_type === "School" && options.requireSchoolGraduation !== false)) && !trimValue(entry.wh_graduated)) {
      nextErrors.wh_graduated = "Graduation selection is required.";
    }
    if (entry.wh_type === "Driving School") {
      if (!trimValue(entry.wh_hours_of_instruction)) nextErrors.wh_hours_of_instruction = "Hours of instruction are required.";
      if (!trimValue(entry.wh_dot_safety_sensitive || entry.wh_safety_sensitive)) nextErrors.wh_dot_safety_sensitive = "Safety-sensitive selection is required.";
      if (!trimValue(entry.wh_fmcsa || entry.wh_transport_regulation)) nextErrors.wh_fmcsa = "Transport regulation selection is required.";
    }
    if (entry.wh_type === "Military" && !trimValue(entry.wh_branch_service)) nextErrors.wh_branch_service = "Branch of service is required.";

    if (!entry.wh_type) nextErrors.wh_type = "History type is required.";
    const validDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(String(value || "")) && !Number.isNaN(new Date(value).getTime());
    if (entry.wh_datefrom && !validDate(entry.wh_datefrom)) nextErrors.wh_datefrom = "Choose a valid From month.";
    if (!stillWorking && entry.wh_dateto && !validDate(entry.wh_dateto)) nextErrors.wh_dateto = "Choose a valid To month.";
    return nextErrors;
  };


export const mergeResumeHistory = (existing, imported) => {
  const key = (row) => JSON.stringify([row.wh_type, (row.wh_name || "").trim().toLowerCase(), (row.wh_position || "").trim().toLowerCase(), String(row.wh_datefrom || row.wh_datefrom_year || "").slice(0, 7), String(row.wh_dateto || row.wh_dateto_year || "").slice(0, 7), row.wh_status]);
  const seen = new Set(existing.map(key));
  return imported.filter((row) => { const id = key(row); if (seen.has(id)) return false; seen.add(id); return true; }).map((row) => ({ ...createEmptyEntry(), ...row }));
};
